import moment from "moment";
import { Group } from "../interfaces";
import { capitalizeString, getCityNameByCode } from "../shared/util";

export class GroupAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get contact_name() {
        return capitalizeString(this.value.contact_name || '');
    }

    get contact_email() {
        return capitalizeString(this.value.contact_email || '');
    }

    get city(){
        return getCityNameByCode(this.value.city).municipio;
    }

    get created_at() {
        return moment(this.value.created_at).format("YYYY-MM-DD");
    }

    get updated_at() {
        return moment(this.value.updated_at).format("YYYY-MM-DD");
    }

    adapt(): Group {
        return {
            id: this.value.id,
            contact_name: this.contact_name,
            contact_email: this.contact_email,
            nme_grupo_gr : capitalizeString(this.value.nme_grupo_gr || ''),
            nme_clasificacion_gr: capitalizeString(this.value.nme_clasificacion_gr || ''),
            nme_municipio_gr: capitalizeString(this.value.nme_municipio_gr || ''),
            nme_gran_area_gr: capitalizeString(this.value.nme_gran_area_gr?.GRAN_AREA_DE_CONOCIMIENTO || ''),
            nme_area_gr: capitalizeString(this.value.nme_area_gr?.AREA_DE_CONOCIMIENTO || ''),
            nme_area_esp_gr: capitalizeString(this.value.nme_area_esp_gr?.ESPECIALIDAD_DE_CONOCIMIENTO || ''),
            cod_grupo_gr: this.value.cod_grupo_gr || '',
            created_at : this.created_at || '',
            updated_at : this.updated_at || '',
            fcreacion_pd : this.value.fcreacion_pd || '' ,
            description: this.value.description || '',
            actor_type: this.value.actor_type,
            recognized_min: this.value.recognized_min || '',
            features: this.value.features || '',
            city: capitalizeString(this.city || ''),
            url: this.value.url || '',
            codigo_institucion: this.value.codigo_institucion || []
        };
    }
}
